// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__25h1B","productName":"Table_productName__1CSPb"};